module.exports = __webpack_public_path__ + "static/media/codesign_cover.7685f2d8.svg";